export default "__VITE_ASSET__oHlctNHf__"